import { Config, config as globalConfig } from "@shared/envVariables";
import { PropsWithChildren, useEffect } from "react";
import { ConfigContext } from "./useConfig";

declare global {
  function enableDebug(): void;
}

interface ConfigProviderProps extends Readonly<PropsWithChildren> {
  readonly config?: Config;
}
export function ConfigProvider({ children, config }: ConfigProviderProps) {
  const configInUse = config ?? globalConfig;
  useEffect(() => {
    globalThis.enableDebug = () => {
      configInUse.debug.showInfo = true;
    };
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, []);
  return <ConfigContext value={configInUse}>{children}</ConfigContext>;
}
